// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notfound-page-section{
    display: flex;
    flex-direction: column;
    height: 100vh;
    align-items: center;
    justify-content: center;
    row-gap: 20px;
    background: transparent linear-gradient(180deg, #164396 0%, #0F306C 100%) 0% 0% no-repeat padding-box;
}
.wrapper-notfound-page-section{
    margin: auto;
}
.notfound-image-section{
    margin-top: -40px;
    display: grid;
    justify-items: center;
    align-items: center;
}
.notfound-page-content-section{
    text-align: center;
    font: normal normal 300 36px/44px Lato;
    letter-spacing: 0px;
    margin-top: 10px;
    color: var(--neutral-color1);
}
.notfound-page-content-section span{
    font-weight: bold;
}

.notfound-page-content-section .notfound-page-content-item-section:nth-child(2){
    font: normal normal 300 24px/29px Lato;
    letter-spacing: 0px;
    color: var(--neutral-color4);
    margin-top: 10px;
    max-width: 480px;
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .wrapper-notfound-page-section .notfound-image-section svg{
        width: 275px;
        height: 219px;
    }
    .notfound-page-content-section{
        font: normal normal 300 22px/27px Lato;
    }
    .notfound-page-content-section .notfound-page-content-item-section:nth-child(2){
        font: normal normal 300 14px/17px Lato;
        max-width: 286px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/NotFoundPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,qGAAqG;AACzG;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,wCAAwC;AACxC;IACI;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,sCAAsC;QACtC,gBAAgB;IACpB;AACJ","sourcesContent":[".notfound-page-section{\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100vh;\r\n    align-items: center;\r\n    justify-content: center;\r\n    row-gap: 20px;\r\n    background: transparent linear-gradient(180deg, #164396 0%, #0F306C 100%) 0% 0% no-repeat padding-box;\r\n}\r\n.wrapper-notfound-page-section{\r\n    margin: auto;\r\n}\r\n.notfound-image-section{\r\n    margin-top: -40px;\r\n    display: grid;\r\n    justify-items: center;\r\n    align-items: center;\r\n}\r\n.notfound-page-content-section{\r\n    text-align: center;\r\n    font: normal normal 300 36px/44px Lato;\r\n    letter-spacing: 0px;\r\n    margin-top: 10px;\r\n    color: var(--neutral-color1);\r\n}\r\n.notfound-page-content-section span{\r\n    font-weight: bold;\r\n}\r\n\r\n.notfound-page-content-section .notfound-page-content-item-section:nth-child(2){\r\n    font: normal normal 300 24px/29px Lato;\r\n    letter-spacing: 0px;\r\n    color: var(--neutral-color4);\r\n    margin-top: 10px;\r\n    max-width: 480px;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .wrapper-notfound-page-section .notfound-image-section svg{\r\n        width: 275px;\r\n        height: 219px;\r\n    }\r\n    .notfound-page-content-section{\r\n        font: normal normal 300 22px/27px Lato;\r\n    }\r\n    .notfound-page-content-section .notfound-page-content-item-section:nth-child(2){\r\n        font: normal normal 300 14px/17px Lato;\r\n        max-width: 286px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
